import { Link } from "react-router-dom";

export default function DeliverymanPrivacyPolicy() {
  return (
    <div
      className="login-page"
      style={{
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container-xxl">
        <div className="card mt-4" style={{ height: "90vh" }}>
          <div className="card-header text-center">
            <Link className="brand-link clearfix" to={"/login"}></Link>
          </div>

          <div className="card-body overflow-auto">
            <h2 className="text-center">Privacy Policy</h2>

            <section>
              <p>
                VIZPRO built the VizLink Deliveryman app as a free app. This
                Service is provided by VIZPRO at no cost and is intended for use
                as is.
              </p>
              <p>
                This Privacy Policy explains how we collect, use, and protect
                information when you use the VizLink Deliveryman app.
              </p>
              <p>
                By using this Service, you agree to the collection and use of
                information in accordance with this Privacy Policy. The
                information we collect is used only to provide, operate, and
                improve the Service. We do not sell your personal information or
                share it with anyone except as described in this Privacy Policy.
              </p>
            </section>

            <section>
              <b>Information Collection and Use</b>
              <p>
                For a better experience while using our Service, we may require
                you to provide certain personally identifiable information,
                including but not limited to:
              </p>
              <ul>
                <li>Name</li>
                <li>CNIC</li>
                <li>Contact Number</li>
                <li>Deliveryman account details</li>
                <li>
                  Transaction or service-related information required to perform
                  deliveryman operations
                </li>
              </ul>
              <p>
                The information requested by the app is retained by us and used
                only for providing and improving the Service.
              </p>
            </section>

            <section>
              <b>Third-Party Services</b>
              <p>
                The app may use third-party services that may collect
                information used to identify you.
              </p>
              <p>
                Privacy policies of third-party service providers used by the
                app:
              </p>
              <ul>
                <li>
                  <a
                    href="https://www.google.com/policies/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Google Play Services
                  </a>
                </li>
                <li>
                  <a
                    href="https://firebase.google.com/policies/analytics"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Google Analytics for Firebase
                  </a>
                </li>
                <li>
                  <a
                    href="https://sentry.io/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sentry
                  </a>
                </li>
              </ul>
            </section>

            <section>
              <b>Log Data</b>
              <p>
                We want to inform you that whenever you use our Service, in case
                of an error in the app, we may collect data and information
                through third-party products called Log Data.
              </p>
              <p>
                This Log Data may include information such as your device IP
                address, device name, operating system version, app
                configuration, the time and date of your use of the Service, and
                other statistics.
              </p>
            </section>

            <section>
              <b>Cookies</b>
              <p>
                This Service does not use cookies explicitly. However, the app
                may use third-party code and libraries that use cookies or
                similar technologies to collect information and improve their
                services.
              </p>
            </section>

            <section>
              <b>Service Providers</b>
              <p>
                We may employ third-party companies and individuals for the
                following reasons:
              </p>
              <ul>
                <li>To facilitate our Service</li>
                <li>To provide the Service on our behalf</li>
                <li>To perform Service-related services</li>
                <li>To assist us in analyzing how our Service is used</li>
              </ul>
              <p>
                These third parties may have access to your Personal Information
                only to perform tasks assigned to them on our behalf. They are
                obligated not to disclose or use the information for any other
                purpose.
              </p>
            </section>

            <section>
              <b>Security</b>
              <p>
                We value your trust in providing us your Personal Information.
                We strive to use commercially acceptable means of protecting it.
              </p>
              <p>
                However, no method of transmission over the internet or method
                of electronic storage is 100% secure and reliable. Therefore, we
                cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <b>Links to Other Sites</b>
              <p>
                This Service may contain links to other sites. If you click on a
                third-party link, you will be directed to that site.
              </p>
              <p>
                Please note that these external sites are not operated by us. We
                strongly advise you to review the Privacy Policy of these
                websites. We have no control over and assume no responsibility
                for the content, privacy policies, or practices of third-party
                sites or services.
              </p>
            </section>

            <section>
              <b>Children’s Privacy</b>
              <p>
                This Service is not intended for anyone under the age of 13.
              </p>
              <p>
                We do not knowingly collect personally identifiable information
                from children under 13 years of age. If we discover that a child
                under 13 has provided personal information, we will immediately
                delete it from our servers.
              </p>
              <p>
                If you are a parent or guardian and you are aware that your
                child has provided us with personal information, please contact
                us so we can take the necessary action.
              </p>
            </section>

            <section>
              <b>Changes to This Privacy Policy</b>
              <p>
                We may update this Privacy Policy from time to time. You are
                advised to review this page periodically for any changes.
              </p>
              <p>Any changes will be posted on this page.</p>
              <p>This policy is effective as of 2026-07-01.</p>
            </section>

            <section>
              <b>Contact Us</b>
              <p>
                If you have any questions or suggestions about this Privacy
                Policy, please contact us at:
              </p>
              <p>
                <a href="mailto:info@vizpro.com.pk">info@vizpro.com.pk</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
